<template>
    <div class="col-md-12">
        <button class="btn btn-success" style="border-radius: 2px !important;" @click="openModalGroup()">
            <i class="fas fa-users"></i> Adicionar novo grupo
        </button>

        <b-row>
            <b-col md="12">
                <b-table striped hover bordered sort-icon-left show-empty :items="tbData" :fields="fields"
                    :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered"
                    :current-page="currentPage" :per-page="perPage" thead-class="font-weight-bold">

                    <template v-if="loading" #empty>
                        <div class="text-center">
                            <b-spinner variant="dark" small></b-spinner> Processando, por favor, aguarde...
                        </div>
                    </template>

                    <template v-else #empty>
                        <h6 style="text-align: center">Nenhum resultado encontrado.</h6>
                    </template>

                    <template #cell(created_at)="data">
                        {{ formatDate(data.item.created_at) }}
                    </template>

                    <template #cell(members)="data">
                        <span v-for="(member, idx) in data.item.members" :key="`${member.id}_${idx}`"
                            class="badge badge-primary badge-member">{{ member.name }}</span>
                    </template>

                    <template v-slot:cell(view-button)="{ item }">
                        <span>
                            <b-btn id="view-button" @click.prevent="openModalGroup(item)"
                                style="border-radius: 3px !important;">
                                <i class="far fa-eye" aria-hidden="true"></i>
                            </b-btn>
                        </span>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <b-row class="justify-content-between">
            <b-col md="4">
                <b-form-group label="Registros por página" label-for="per-page-select" label-cols-md="6"
                    label-align-sm="right" label-size="sm" class="mb-0 align-self-center">
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" size="md"
                    class="my-0"></b-pagination>
            </b-col>
        </b-row>

        <GroupsTicketModal ref="addGroupModal" @updateGroupTable="updateTable"></GroupsTicketModal>
    </div>
</template>

<script>
import axios from 'axios';
import GroupsTicketModal from './GroupsTicketModal.vue';
import { formatDate } from "../../../helpers/utils";

export default {
    name: "ManageGroups",
    components: { GroupsTicketModal },
    data() {
        return {
            tbData: [],
            loading: false,
            dataEdit: {
                id: 0,
                name: "",
                members: [],
            },
            fields: [
                {
                    key: 'created_at',
                    label: 'Data',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'name',
                    label: 'Nome',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'members',
                    label: 'Membros',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'view-button',
                    label: 'Visualizar',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff', width: '100px' }
                },
            ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Ver mais" }],
            sortBy: '',
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
        }
    },
    created() {
        this.getDataTable();
    },
    methods: {
        formatDate,
        openModalGroup(value = null) {
            this.$refs.addGroupModal.openModal(value);
        },
        // Remove membros duplicados (mesmo id repetido no array members)
        dedupeMembers(members) {
            const seen = new Set();
            return (members ?? []).filter(m => {
                if (seen.has(m.id)) return false;
                seen.add(m.id);
                return true;
            });
        },
        getDataTable() {
            axios.get("/ticket/groups")
                .then(({ data }) => {
                    this.tbData = data.map(group => ({
                        ...group,
                        members: this.dedupeMembers(group.members),
                    }));
                    this.totalRows = this.tbData.length;
                })
                .catch((error) => console.error(error))
        },
        updateTable(data) {
            if (!data.id) return;
            const resolved = { ...data, members: this.dedupeMembers(data.members) };
            const found = this.tbData.find(el => el.id === data.id);
            if (found) {
                Object.assign(found, resolved);
            } else {
                this.tbData.push(resolved);
                this.totalRows++;
            }
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
    }
}
</script>

<style scoped>
.badge-member {
    margin: 0px 5px;
    font-size: 1em;
}
</style>